<!--
  VPreloader

  還原自 chunk-common.pretty.js L703。render function 已轉回 template。

  原始為 staticRenderFns[0]（無任何動態繫結的靜態片段），
  10 個空 div 由 CSS 的 .preloader > div 依 nth-child 做動畫延遲。
-->

<template>
  <div class="preloader">
    <div></div>
    <div></div>
    <div></div>
    <div></div>
    <div></div>
    <div></div>
    <div></div>
    <div></div>
    <div></div>
    <div></div>
  </div>
</template>

<script>
export default {
  data() {
    return {}
  },
  methods: {}
}
</script>
